export const insightsExtractedMessages = {
  "insights.DashboardPage.addABookToStartTrackingYour":
    "Add a book to start tracking your reading and see it here.",
  "insights.DashboardPage.addYourFirstBook": "Add your first book",
  "insights.DashboardPage.aQuietPlaceToPickUpWhere":
    "A quiet place to pick up where you left off.",
  "insights.DashboardPage.browseYourLibrary": "Browse your library",
  "insights.DashboardPage.chooseABookFromYourLibraryAnd":
    "Choose a book from your library and mark it as reading.",
  "insights.DashboardPage.chooseMinutesPagesReadingDaysOrCompleted":
    "Choose minutes, pages, reading days, or completed books.",
  "insights.DashboardPage.continueReading": "Continue reading",
  "insights.DashboardPage.goalProgress": "Goal progress",
  "insights.DashboardPage.goalProgressUnavailable": "Goal progress unavailable",
  "insights.DashboardPage.goodAfternoon": "Good afternoon",
  "insights.DashboardPage.goodEvening": "Good evening",
  "insights.DashboardPage.goodMorning": "Good morning",
  "insights.DashboardPage.loadingReadingBook": "Loading reading book",
  "insights.DashboardPage.loadingReadingGoals": "Loading reading goals",
  "insights.DashboardPage.loadingReadingSummary": "Loading reading summary",
  "insights.DashboardPage.loadingRecentActivity": "Loading recent activity",
  "insights.DashboardPage.loadingWeeklyReadingChart": "Loading weekly reading chart",
  "insights.DashboardPage.logAReadingSessionAndItWill":
    "Log a reading session and it will appear here.",
  "insights.DashboardPage.logProgress": "Log progress",
  "insights.DashboardPage.manageGoals": "Manage goals",
  "insights.DashboardPage.noBookInProgress": "No book in progress",
  "insights.DashboardPage.noGoalYet": "No goal yet",
  "insights.DashboardPage.noRecentReading": "No recent reading",
  "insights.DashboardPage.readingBooks": "reading books",
  "insights.DashboardPage.readingSummaryUnavailable": "Reading summary unavailable",
  "insights.DashboardPage.recentActivity": "Recent activity",
  "insights.DashboardPage.recentActivityCouldNotBeLoaded":
    "Recent activity could not be loaded",
  "insights.DashboardPage.retryActivity": "Retry activity",
  "insights.DashboardPage.retryGoals": "Retry goals",
  "insights.DashboardPage.retryLibrary": "Retry library",
  "insights.DashboardPage.retrySummary": "Retry summary",
  "insights.DashboardPage.retryWeeklyReading": "Retry weekly reading",
  "insights.DashboardPage.setAReadingGoal": "Set a reading goal",
  "insights.DashboardPage.viewAll": "View all",
  "insights.DashboardPage.weeklyReadingChart": "Weekly reading chart",
  "insights.DashboardPage.weeklyReadingCouldNotBeLoaded":
    "Weekly reading could not be loaded",
  "insights.DashboardPage.yourLibraryCouldNotBeLoaded":
    "Your library could not be loaded",
  "insights.DashboardPage.yourLibraryIsEmpty": "Your library is empty",
  "insights.DashboardPage.yourPaceForTheCurrentLocalPeriod":
    "Your pace for the current local period.",
  "insights.GoalProgressList.of": "of",
  "insights.ReadingGoalManager.addGoal": "Add goal",
  "insights.ReadingGoalManager.cadence": "Cadence",
  "insights.ReadingGoalManager.chooseAMeasureBelowToCreateYour":
    "Choose a measure below to create your first recurring goal.",
  "insights.ReadingGoalManager.goalChangeCouldNotBeSaved":
    "Goal change could not be saved",
  "insights.ReadingGoalManager.measure": "Measure",
  "insights.ReadingGoalManager.monthly": "Monthly",
  "insights.ReadingGoalManager.noReadingGoalsYet": "No reading goals yet",
  "insights.ReadingGoalManager.previousPeriodOutcomes": "Previous period outcomes",
  "insights.ReadingGoalManager.readingGoals": "Reading goals",
  "insights.ReadingGoalManager.remove": "Remove",
  "insights.ReadingGoalManager.setAWeeklyOrMonthlyPaceProgress":
    "Set a weekly or monthly pace. Progress follows your local calendar.",
  "insights.ReadingGoalManager.target": "Target",
  "insights.ReadingGoalManager.weekly": "Weekly",
  "insights.ReadingWeekSummary.readingSummary": "Reading summary",
  "insights.RecentActivityList.min": "min",
  "insights.RecentActivityList.pages": "pages",
  "insights.RecentActivityList.readingJournal": "Reading journal",
  "insights.RecentActivityList.recentActivity": "Recent activity",
  "insights.RecentActivityList.viewJournal": "View journal",
  "insights.TodayQuickActions.chooseReadingBook": "Choose a reading book",
  "insights.TodayQuickActions.description":
    "Keep the next step close, whether you are reading, reflecting, or planning.",
  "insights.TodayQuickActions.eyebrow": "Quick actions",
  "insights.TodayQuickActions.onboardingDescription":
    "Add a book first, then mark it as reading to unlock progress and goals here.",
  "insights.TodayQuickActions.onboardingTitle": "Start your reading journey",
  "insights.TodayQuickActions.openJournal": "Open journal",
  "insights.TodayQuickActions.reviewGoals": "Review goals",
  "insights.TodayQuickActions.title": "What would you like to do?",
  "insights.RecommendationsPage.addOrTunePreferencesOrImportMore":
    "Add or tune preferences, or import more catalog books before checking again. Books already in your library and dismissed items stay excluded.",
  "insights.RecommendationsPage.because": "Because",
  "insights.RecommendationsPage.bookRecommendations": "Book recommendations",
  "insights.RecommendationsPage.discover": "Discover",
  "insights.RecommendationsPage.dismiss": "Dismiss",
  "insights.RecommendationsPage.englishSpanish": "English, Spanish",
  "insights.RecommendationsPage.enterCommaSeparatedValuesYouCanChange":
    "Enter comma-separated values. You can change or reset these private signals at any time.",
  "insights.RecommendationsPage.fantasyHistoryMystery": "Fantasy, History, Mystery",
  "insights.RecommendationsPage.horrorExplicitViolence": "Horror, explicit violence",
  "insights.RecommendationsPage.loadingRecommendations": "Loading recommendations",
  "insights.RecommendationsPage.next": "Next",
  "insights.RecommendationsPage.noNewRecommendations": "No new recommendations",
  "insights.RecommendationsPage.notInterested": "Not interested",
  "insights.RecommendationsPage.page": "Page",
  "insights.RecommendationsPage.preferredGenres": "Preferred genres",
  "insights.RecommendationsPage.preferredLanguages": "Preferred languages",
  "insights.RecommendationsPage.previous": "Previous",
  "insights.RecommendationsPage.readingPreferences": "Reading preferences",
  "insights.RecommendationsPage.recommendationPages": "Recommendation pages",
  "insights.RecommendationsPage.recommendationsCouldNotBeUpdatedPleaseTry":
    "Recommendations could not be updated. Please try again.",
  "insights.RecommendationsPage.recommendationsUseYourExplicitPreferencesLibraryHistory":
    "Recommendations use your explicit preferences, library history, and privacy-safe published ratings. Private journal text is never used.",
  "insights.RecommendationsPage.resetSignals": "Reset signals",
  "insights.RecommendationsPage.save": "Save",
  "insights.RecommendationsPage.savePreferences": "Save preferences",
  "insights.RecommendationsPage.theseAreColdStartSuggestionsAddPreferences":
    "These are cold-start suggestions. Add preferences or books to make them more personal.",
  "insights.RecommendationsPage.topicsToExclude": "Topics to exclude",
  "insights.RecommendationsPage.tunePreferences": "Tune preferences",
  "insights.StatsPage.activeDays": "Active days",
  "insights.StatsPage.averageActiveDay": "Average / active day",
  "insights.StatsPage.averageSession": "Average / session",
  "insights.StatsPage.books": "Books",
  "insights.StatsPage.booksInProgress": "Books in progress",
  "insights.StatsPage.chartMeasure": "Chart measure",
  "insights.StatsPage.clearPatternsFromYourReadingWithEvery":
    "See when, how much, and what you have been reading.",
  "insights.StatsPage.dailyActivityOverTheSelectedPeriod":
    "Daily activity over the selected period.",
  "insights.StatsPage.date": "Date",
  "insights.StatsPage.didNotFinish": "Did not finish",
  "insights.StatsPage.finished": "Finished",
  "insights.StatsPage.insights": "Insights",
  "insights.StatsPage.insightsDateRange": "Insights date range",
  "insights.StatsPage.last30Days": "Last 30 days",
  "insights.StatsPage.last7Days": "Last 7 days",
  "insights.StatsPage.last90Days": "Last 90 days",
  "insights.StatsPage.lastYear": "Last year",
  "insights.StatsPage.librarySnapshot": "Library snapshot",
  "insights.StatsPage.loadingReadingInsights": "Loading reading insights",
  "insights.StatsPage.minutes": "Minutes",
  "insights.StatsPage.noBooksAreCurrentlyMarkedAsReading":
    "No books are currently marked as reading.",
  "insights.StatsPage.onceYouLogAReadingSessionThis":
    "Log a reading session to see your activity here.",
  "insights.StatsPage.pages": "Pages",
  "insights.StatsPage.pagesRead": "Pages read",
  "insights.StatsPage.reading": "Reading",
  "insights.StatsPage.readingOverview": "Reading overview",
  "insights.StatsPage.readingRhythm": "Reading rhythm",
  "insights.StatsPage.sessions": "Sessions",
  "insights.StatsPage.someInsightsCouldNotBeLoaded":
    "Some insights could not be loaded",
  "insights.StatsPage.timeRead": "Time read",
  "insights.StatsPage.toRead": "To read",
  "insights.StatsPage.tryAgain": "Try again",
  "insights.StatsPage.viewChartData": "View chart data",
  "insights.StatsPage.wishlist": "Wishlist",
  "insights.StatsPage.yourInsightsAreWaitingForAFirst": "No reading sessions yet",
  "insights.StatsPage.activityUnavailable": "Reading activity unavailable",
  "insights.StatsPage.activityUnavailableDescription":
    "We could not load the selected period. Try again when the connection is restored.",
  "insights.StatsPage.bookProgress": "{title}: {percentage}% complete",
  "insights.StatsPage.booksUnavailable": "Book progress could not be loaded.",
  "insights.StatsPage.chartSummary":
    "{metric}: {total} from {start} through {end}. The chart is followed by the complete data table.",
  "insights.StatsPage.durationHours": "{hours} hr",
  "insights.StatsPage.durationHoursMinutes": "{hours} hr {minutes} min",
  "insights.StatsPage.durationMinutes": "{minutes} min",
  "insights.StatsPage.goalsUnavailable": "Reading goals unavailable",
  "insights.StatsPage.loadingReadingGoals": "Loading reading goals",
  "insights.StatsPage.pagesValue": "{count} pages",
  "insights.StatsPage.periodAndTimezone":
    "{start}–{end}. Calendar dates use your profile timezone ({timezone}); sessions remain on the local date recorded when you read.",
  "insights.StatsPage.periodSummary": "Selected-period summary",
  "insights.StatsPage.showAllRows": "Show all {count} days",
  "insights.StatsPage.snapshotUnavailable": "Library totals could not be loaded.",
  "insights.StatsPage.summary":
    "You read {pages} pages in {duration}, across {sessions} on {days}.",
  "insights.StatsPage.tableCaption":
    "Daily reading activity. Dates are recorded local dates; the selected range is anchored in {timezone}.",
  "insights.StatsPage.timezoneNote":
    "Calendar dates use your profile timezone ({timezone}); sessions remain on the local date recorded when you read.",
  "insights.WeeklyReadingChart.minTotal": "min total",
  "insights.WeeklyReadingChart.minutes": "minutes",
  "insights.WeeklyReadingChart.minutesReadEachDayThisWeek":
    "Minutes read each day this week",
  "insights.WeeklyReadingChart.noReadingRecordedThisWeekYetYour":
    "No reading recorded this week yet. Your next session will appear here.",
  "insights.WeeklyReadingChart.readingRhythm": "Reading rhythm",
  "insights.WeeklyReadingChart.thisWeek": "This week",
} as const;
